import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  categories: [],
  selectedCategories: [],
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    setCategories: (state, action) => {
      state.categories = action.payload;
    },
    setSelectedCategories: (state, action) => {
      state.selectedCategories = action.payload;
    },
    clearCategories: (state) => {
      state.categories = [];
      state.selectedCategories = [];
    },
  },
});

export const { setCategories, setSelectedCategories, clearCategories } = categoriesSlice.actions;
export default categoriesSlice.reducer;

export const fetchCategoriesAction = (categories) => (dispatch) => {
  if (categories.length > 0) {
    const categoriesList = categories.map((category) => ({
      key: category.name,
      name: category.name,
      templateNameWithCount: `${category.name} (${category.templateCount} ${category.templateCount == 1 ? 'template' : 'templates'})`,
      value: category.id,
    }));
    dispatch(setCategories(categoriesList));
  } else {
    dispatch(setCategories([]));
  }
};
export const clearCategoriesAction = (data) => async dispatch => {
  dispatch(clearCategories());
}